<footer class="site-footer">
  <div class="footer-container">
    <!-- Brand / About -->
    <div class="footer-col">
      <h3> <div class="logo">
        <img src="KabbodleLogo.png" class="logoimg" alt="Kaboodle Logo"/>
      </div></h3>
      <p class="footer-desc">
        Kaboodle is an early childhood education platform empowering educators
        with research-backed courses and classroom-ready strategies.
      </p>
    </div>

    <!-- Contact Info -->
    <div class="footer-col">
      <h4>Contact Us</h4>
      <ul class="footer-list contact-list">
        <li>
          <i class="bi bi-geo-alt-fill"></i>
          <span>
            Tower B, 6th Floor, Bhutani Cyberpark, C Block, Phase 2, Industrial
            Area, Sector 62, Noida, Uttar Pradesh 201309
          </span>
        </li>

        <li>
          <i class="bi bi-envelope-fill"></i>
          <a href="mailto:info@kaboodle.in">info@kaboodle.in</a>
        </li>

        <li>
          <i class="bi bi-telephone-fill"></i>
          <a href="tel:+919871268882">+91-9871268882</a>
        </li>
      </ul>
    </div>

    <!-- Quick Links -->
    <div class="footer-col">
      <h4>Quick Links</h4>
      <ul class="footer-list">
        <li><a [routerLink]="['/home']">Home</a></li>
        <li>
          <a [routerLink]="['/']" fragment="video-learning"> Courses </a>
        </li>

        <!-- <li><a href="#">About Us</a></li> -->
        <li>
          <a href="https://www.kaboodleinnovations.com/privacy-policy"
            >Privacy Policy</a
          >
        </li>
      </ul>
    </div>
  </div>

  <!-- Bottom Bar -->
  <div class="footer-bottom">
    <p>
      © 2023 Kaboodle Early Childhood Education Platform. All rights reserved.
    </p>
  </div>
</footer>
